import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { editPage } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { PageProvider } from '../../../PageContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import PageEditContent from '../../../components/Dashboard/PageEditContent'


const SinglePageEdit = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'Pages.List.EditPage.Title' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={editPage.image}
               description={intl.formatMessage({ id: 'Pages.List.EditPage.Title' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall, adminSectionType }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <PageProvider adminSectionType={adminSectionType} pageAction={'edit'} pid={id}
                                  handleNotificationCall={handleNotificationCall}>
                      <PageEditContent adminSectionType={adminSectionType}
                                       pageTitle={<FormattedMessage id='Pages.List.EditPage.Title'/>}/>
                    </PageProvider>
                  }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.workspace.page.list}/>
      }
    </>
  )
}

export default SinglePageEdit

